const config = {
  version: '2.5.1',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts